// @ts-nocheck

export default class Photos {
  constructor($http, Endpoints) {
    Object.assign(this, {
      $http,
      Endpoints,
    });
  }

  deletePhoto(photo_id) {
    return this.$http.delete(this.Endpoints.orders.delete_photo.replace(':id', photo_id));
  }

  deletePhotoNew(photo_id):Promise<any> {
    return this.$http.delete(this.Endpoints.orders.delete_photo.replace(':id', photo_id));
  }
}

Photos.$inject = ["$http", "Endpoints"];
